
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'AppStore'
})
export default class AppStore extends Vue {}
